<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import SitePreviewPage from '@/views/apps/sites/SitePreviewPage.vue'

definePage({ meta: { ...PageMeta.Sites.Preview.Meta, pageTitle: PageMeta.Sites.Preview.Title } })

const route = useRoute()

const siteGuid = computed(() => {
  const params = route.params as Record<string, string | string[] | undefined>
  const guid = params.guid

  return Array.isArray(guid) ? guid[0] : guid
})
</script>

<template>
  <SitePreviewPage
    v-if="siteGuid"
    :site-guid="siteGuid"
  />
</template>
